<template>
  <div class="wrapper">
    <BusinessHeader v-if="this.isloginHendle"></BusinessHeader>
    <HeaderNav menuflg="2" v-else></HeaderNav>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
    _/                                                                                                                    _/
    _/      画面定義                                                                                                      _/
    _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
    <div class="body">
      <div class="inner  padding-b-5px">
        <div class="pankuzu">
          <ul >
            <li>
              <router-link 
                class="ico-home" 
                :to="{ name: this.formInfo.isBop ? 'STFMFM02C29' : 'STFMFM01C01' }"
              >
              {{ this.formInfo.isBop ? "ファイル一覧" : "メインページ"}}
              </router-link>
            </li>
           <li v-if="!this.isloginHendle">
              <router-link 
                :to="{ name: 'STFMFM02C01'}"
              >
              ファイル管理
            </router-link>
            </li>
           <li v-if="!this.isloginHendle">
              <router-link
               :to="{ name: 'STFMFM02C29' }"
              >
              ファイル一覧
              </router-link>
            </li>
            <li>
              <span class="current">ファイル詳細</span>
            </li>
          </ul>
        </div>
        
        <div class="content-header">
          <h1 class="h1">ファイル詳細</h1>
          <p class="sub-title">{{ this.formInfo.businessOperatorCode }}{{ this.formInfo.businessOperatorName }}</p>
        </div>
        <!-- ****  メッセージ表示領域 **** -->
        <p 
          class="errMsg title-ico ico-warning mt-10px" 
          v-show="errors != ''"
        >
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <div> <p class="lead mt-20px">{{ this.guide }}</p></div>
      </div>
      <div class="inner block padding-t-10px">
        <div class="single-pagination mb-15px">
          <a 
            class="prev" 
            href=""
            @click.prevent="handlePrevFileBtnClicked"
            :class="this.isPrevFileBtnDisabled()?noLinks:''"
            ref="refPrevFileBtn"
          >
            前のファイル
          </a>
          <a 
            class="next" 
            href=""
            @click.prevent="handleNextFileBtnClicked"
            :class="this.isNextFileBtnDisabled()?noLinks:''"
            ref="refNextFileBtn"
          >
            次のファイル
          </a>
        </div>
        <div class="frm-row">
          <div class="frm-item grow left">
            <div>
              <span class="frm-label">改訂履歴</span>
              <select
                v-show="this.isEtf"
                v-model="currentVersionName"
                class="frm-select frm-size-m mr-10px"
                @change="handleChangeVersionSelect"
                :disabled="this.isChangeVersionSelectDisabled()"
                ref="refVersionSelect"
              >
                <option
                  v-for="item in this.versionNameList"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </div>
          
            <button 
              class="frm-btn text ml-0"
              type="button" 
              @click="handleDownloadFileBtnClicked" 
              :disabled="this.isDownloadFileBtnDisabled()"
              ref="refDownloadFileBtn"
            >
              ダウンロード
            </button>
            <!-- No4スキャナ保存対応-スキャナ保存読取要件チェック start  -->
            <button class="frm-btn text ml-0" type="button" @click="checkFile">
              スキャナ保存読取要件チェック
            </button>
          </div>
          <div class="frm-item grow right" v-if="this.showEditFileButton">
   
            <!-- No4スキャナ保存対応-スキャナ保存読取要件チェック end  -->
            <button
              class="frm-btn-control strong text ico ico-revision"
              type="button"
              @click="handleEditFileInfoBtnClicked"
              :disabled="this.isEditFileInfoBtnDisabled()"
              ref="refEditFileInfoBtn"
            >
            改訂
            </button>
          </div>
        </div>
        <div class="property-wrap mt-15px">
          <div class="property-left" style="background-color:#e9edf7">
            <div class="frm-row preview-control"  v-if="pdfUrl!=''">
              <label>
                <font>※PDFに変換して表示しているため実際のイメージと異なる場合がございます。</font>
              </label>
            </div>
            <div class="preview-area mt-8px height-1020px">
              <iframe 
                v-if="!isMobile"
                :src="pdfUrl"
                type="application/pdf"
                width=100%
                height=100%
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                border="0"
                scrolling="no"
                tabindex="-1"
              >
              </iframe>
              <pdf-viewer  v-if="isMobile"  :url="pdfUrl"/>
            </div>
          </div>
          <div class="property-right">
            <div v-if="this.isEtf">
              <p><strong>取引情報</strong></p>
              <div class="para mb-40p">
                <div class="frm-row ml-15px">
                  <span class="frm-label w-100px">取引年月日</span>
                  <span class="frm-label">{{ this.blandkToHyphen(this.formInfo.issueDateWareki) }}</span>
                </div>
                <div class="display-flex">
                  <div class="frm-label w-100px mt-20px ml-15px position-absolute">取引先</div>
                  <div class="mt-20px ml-110px">
                    <span class="frm-label break-all ml-15px">{{ this.blandkToHyphen(this.formInfo.company) }}</span>
                  </div>
                </div>
                <div class="frm-row mt-20px ml-15px">
                  <span class="frm-label w-100px">取引金額</span>
                  <span class="frm-label">{{ this.blandkToHyphen(this.formInfo.amount) }}
                    <span 
                      class="frm-label strong"
                      v-if="!this.amountIsEmpty()"
                    >円
                    </span>
                  </span>

                </div>
              </div>
            </div>
            <div v-if="this.isEtf">
              <p><strong>{{ this.updateLabelName }}</strong></p>
              <div class="para mb-40px">
                <div class="frm-row ml-15px">
                  <span class="frm-label w-100px">{{ this.updateDateLabelName }}</span>
                  <span class="frm-label">{{ this.updateTime }}</span>
                </div>
                <div class="display-flex">
                  <div class="frm-label w-100px mt-20px ml-15px position-absolute">{{ this.updaterLabelName }}</div>
                  <div class="mt-20px ml-110px">
                    <span class="frm-label break-all ml-15px">
                      {{ this.updater }}</span>
                  </div>
                </div>
                <div v-if="this.showUpdateReasonFlg" class="display-flex">
                  <div 
                    class="frm-label w-100px mt-20px ml-15px position-absolute" 
                  >
                    改訂理由
                  </div>
                  <div class="mt-20px ml-110px">
                    <span class="frm-label break-all ml-15px" ref="refUpdateReason">
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!this.isEtf">
              <p><strong>保存履歴</strong></p>
              <div class="para mb-40px">
                <div class="frm-row ml-15px">
                  <span class="frm-label w-100px">作成日時</span>
                  <span class="frm-label">{{ this.formInfo.createDate }}</span>
                </div>
                <div class="display-flex">
                  <div class="frm-label w-100px mt-20px ml-15px position-absolute">作成者</div>
                  <div class="mt-20px ml-110px">
                    <span class="frm-label break-all ml-15px">
                      {{ this.formInfo.createName }}
                    </span>
                  </div>
                </div>
                <div class="frm-row mt-20px ml-15px">
                  <span class="frm-label w-100px">保存日時</span>
                  <span class="frm-label">{{ this.formInfo.updateDate }}</span>
                </div>
                <div class="display-flex">
                  <div class="frm-label w-100px mt-20px ml-15px position-absolute">保存者</div>
                  <div class="mt-20px ml-110px">
                    <span class="frm-label break-all ml-15px">
                      {{ this.formInfo.updateName }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="frm-row br-top"></div>
            <div 
              v-if="this.showEditPropetyButton" 
              class="display-flex justify-space-between" 
            >
              <span :style="{order: isMobile? 2:1}" ><p><strong>プロパティ</strong></p></span>
              <span :style="{order: isMobile? 1:2}">
                <button
                  class="frm-btn-control ico ico-edit text"
                  type="button"
                  @click="handleEditPropertyBtnClicked"
                  :disabled="this.isEditPropertyBtnDisabled()"
                  ref="refEditPropertyBtn"
                >
                  編集
                </button>
              </span>
            </div>
            <div class="para mb-40p">
              <div class="display-flex">
                <div class="frm-label w-100px ml-15px position-absolute">名称</div>
                <div class="ml-110px ">
                  <span class="frm-label break-all ml-15px">{{ this.formInfo.fileName }}</span>
                </div>
              </div>
              <!-- No4書類ID start-->
              <div class="display-flex">
                <div
                  class="frm-label w-100px mt-20px ml-16px position-absolute"
                >
                  書類ID
                </div>
                <div class="mt-20px ml-110px">
                  <span class="frm-label break-all ml-15px">{{
                    this.formInfo.paperID
                  }}</span>
                  <!-- No4書類ID -->
                </div>
              </div>
              <!-- No4書類ID end-->
              <div class="frm-row mt-20px ml-15px" v-if="this.isEtf">
                <span class="frm-label w-100px">書類種別</span>
                <span class="frm-label">{{ this.blandkToHyphen(this.formInfo.paperTypeName) }}</span>
              </div>
              <div class="display-flex">
                <div class="frm-label w-100px mt-20px ml-16px position-absolute">備考</div>
                <div class="mt-20px ml-110px">
                  <span class="frm-label break-all ml-15px" ref="refRemarks">
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-30px">
        <div class="mt-30px">
          <a
            href="#"
            class="link-back"
            @click.prevent="handleReturn"
            >戻る</a
          >
        </div>
      </div>
    </div>
    <!-- No4書類ID -->
    <STFMFM02C27UpdatePropertModal
      :isConfirmShow="this.modalSetting.isConfirmShow"
      :fileKey="this.modalSetting.fileKey"
      :pRemarks="this.modalSetting.pRemarks"
      :paperID="this.modalSetting.paperID"
      :pFileType="this.modalSetting.pFileType"
      :pOtherPaperTypeName="this.modalSetting.pOtherPaperTypeName"
      @agree="agreeUpdateProperty($event)"
      @disagree="disagreeUpdateProperty"
    ></STFMFM02C27UpdatePropertModal>
    <!-- No4スキャナ保存対応-スキャナ保存読取要件チェック   start-->
    <ConfirmDialog
      width="550"
      :isShow="fileCheckSuccessedDialog.show"
      :message="fileCheckSuccessedDialog.content"
      @confirm="fileCheckConfirm" 
      :cancelText="fileCheckSuccessedDialog.cancelText"
      :confirmText="fileCheckSuccessedDialog.confirmText"
    >
    </ConfirmDialog>
    <!-- No4スキャナ保存対応-スキャナ保存読取要件チェック  end-->
  </div> 
</template>

<script>
import _ from "lodash";
import Common from "@/util/common.js";
import HeaderNav from "@/components/AccountingHeader.vue";
import BusinessHeader from "@/components/BusinessHeader.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import STFMFM02C27UpdatePropertModal from "@/components/STFMFM02C27UpdatePropertModal.vue";
import { getPDFApi, downloadAsOtherNameApi } from "@/api/filemanage_download";
import { mapMutations } from "vuex";
import { PAPERTYPE_LIST } from "@/util/data.js";
import {
  API_STFMFM02C09_FilePreviewDisplay,
  API_STFMFM02C09_DownloadFile,
  API_STFMFM02C09_CheckFileStatus,
  API_STFMFM02C09_UnlockFile,
  API_STFMFM02C09_RequirementCheck,
} from "@/api/Modules/FM02/STFMFM02C09.js";
// No4スキャナ保存対応
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import PdfViewer from "@/components/PdfViewer.vue"

export default {
  name: "STFMFM02C09FileConfirmation",
  components: {
    ErrorMessage,
    STFMFM02C27UpdatePropertModal,
    HeaderNav,
    BusinessHeader,
    ConfirmDialog,
    PdfViewer
  },
  data() {
    return {
      isMobile:Common.isMobile(),
      /** ログインユーザ区分 */
      isloginHendle: this.$cookies.get("isloginHendle") == "true" ? true : false,
      /** 書類種別 */
      paperList: PAPERTYPE_LIST,
      /** 事業者ID */
      bopID: "",
      /** 事業者名 */
      bopName: "",
      /** ガイド文言 */
      guide: "",
      /** 電子取引か */
      isEtf: true,
      /** 全体エラー情報格納用 */
      errors: [],
      /** PDF表示URL */
      pdfUrl: "",
      /** 画面情報 */
      formInfo: [],
      versionList: [],
      versionNameList: [],
      /** ファイルID件数 */
      fileIdCnt: 0,
      /** バージョン件数 */
      versionCnt: 0,
      /** 改訂ボタン表示制御 */
      showEditFileButton: false,
      /** 編集ボタン表示制御 */
      showEditPropetyButton: false,
      /** 更新者作成者表示制御 */
      updateLabelName: "",
      updateDateLabelName: "",
      updateTime: "",
      updaterLabelName: "",
      updater: "",
      showUpdateReasonFlg: false,
      /** 現表示中ファイルIDのIndex */
      currentFileIdIndex: 0,
      /** 現表示中バージョンのIndex */
      currentVersionNameListIndex: 0,
      /** 現表示中バージョン名 */
      currentVersionName: "",
      /** 書類種別 */
      paperTypeName: "",
      /** 処理中フラグ */
      isProcessing: true,
      /** プロパティ編集画面表示用 */
      modalSetting: {},
      /** ファイルアップロード画面表示用 */
      fileUploadModalSetting: {},
      /** 確認画面表示用 */
      confirmDialogSetting: {},
      /** リンクを無効に */
      noLinks: "no-links",
      // No4スキャナ保存対応-スキャナ保存読取要件チェック 
      fileCheckSuccessedDialog: {
        show: false,
        content: "",
        cancelText: "",
        confirmText: "OK",
      },
    };
  },

  /**
   * 初期表示処理
   */
  mounted() {
    // this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // 初期表示時はファイルキーを指定しない
    let params = {};
    this.postFilePreviewDisplay("", params, 0);
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue"]),

    /**
     * 呼び出し元画面に戻る
     */
    handleReturn(){
      this.moveToOtherForm("STFMFM02C29", {});
    },
    /**
     * バージョン表示有効制御
     */
    isChangeVersionSelectDisabled() {
      return this.isProcessing || this.fileIdCnt == 0;
    },
    /**
     * ダウンロードボタン有効制御
     */
    isDownloadFileBtnDisabled() {
      return this.isProcessing || this.fileIdCnt == 0;
    },
    /**
     * プロパティ編集ボタン有効制御
     */
    isEditPropertyBtnDisabled() {
      var bRet = (this.isProcessing || this.fileIdCnt == 0) ?
        true :
        false;
      return bRet;
    },
    /**
     * 改訂ボタン有効制御
     */
    isEditFileInfoBtnDisabled() {
      var bRet = (this.versionCnt >= 10 || this.isProcessing || this.fileIdCnt == 0) ?
        true :
        false;
      return bRet;
    },
    /**
     * 前ファイル有効制御
     */
    isPrevFileBtnDisabled() {
      var bRet = (this.isProcessing || this.currentFileIdIndex == 0 || this.fileIdCnt == 0)?
        true :
        false;
      return bRet;
    },
    /**
     * 次ファイル有効制御
     */
    isNextFileBtnDisabled() {
      var bRet = (this.isProcessing || this.currentFileIdIndex == this.fileIdCnt - 1 || this.fileIdCnt == 0) ?
        true :
        false;
      return bRet;
    },

    /**
     * ファイルダウンロードボタン押下イベント
     */
    handleDownloadFileBtnClicked(){
      this.processDialogue(true);
      this.resetErrorFlg();

      this.isProcessing = true;
      
      var fileKey = this.formInfo.fileKey;
      let params = {
        FileKey: fileKey
      };

      API_STFMFM02C09_DownloadFile(params).then(async (response) => {
        //正常の場合
        if (response.result == "0000") {
          //正常時
          // ファイルダウンロード No9共通対応Temp問題対応
          const result = await downloadAsOtherNameApi(response, this.formInfo.fileName);
          if (!_.eq(result.result, "0000")) {
            // エラー表示
            this.errors = [];
            this.errors.push(
              Common.createError(
                result.errorCD,
                Common.getMessage(result.errorCD, [])
              )
            );
            this.formToTop();
          }
        } 
        else{     
          // エラー表示
          this.errFlg = true;
          var para = [];
          if (response.msgParamList != null && response.msgParamList.length > 0){
            para = response.msgParamList;
          }
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, para)
            )
          );
          this.formToTop();
        }
        this.processDialogue(false);
        this.isProcessing = false;
        this.$nextTick(function () {
          this.initFocus();
        });
      }
      );
    },
    /**
     * プロパティ編集画面で確定ボタン押下
     */
    agreeUpdateProperty() {
      this.closeUpdatePropertyForm();
      // 画面再表示
      let params = {};
      this.postFilePreviewDisplay("", params, 0);
    },
    /**
     * プロパティ編集画面でキャンセルボタン押下
     */
    disagreeUpdateProperty(){
      this.closeUpdatePropertyForm();
      this.isProcessing = true;
      this.processDialogue(true);
      // アンロック
      API_STFMFM02C09_UnlockFile().then(async (response) => {
        //正常の場合
        if (_.eq(response.result, "0000")) {
          // システムエラーのみのためエラーハンドル不要
        }
        this.processDialogue(false);
        this.isProcessing = false;
      });
    },
    /**
     * プロパティ編集画面非表示
     */
    closeUpdatePropertyForm(){
      this.modalSetting = {
        isConfirmShow: false,
        fileKey: {},
        pRemarks: "",
        pFileType: "",
        pOtherPaperTypeName: "",
      }; 
      this.$nextTick(function () {
        this.$refs.refEditPropertyBtn.focus();
      });
    },
    /**
     * プロパティ編集画面非表示
     */
    showUpdatePropertyForm(response) {
      this.modalSetting = {
        isConfirmShow: true,
        fileKey: response.fileKey,
        pRemarks: response.remarks,
        paperID: response.paperID, // No4書類ID
        pFileType: response.paperType,
        pOtherPaperTypeName: response.otherPaperTypeName,
      };
    },
    /**
     * プロパティ編集ボタン押下
     */
    handleEditPropertyBtnClicked(){
      this.postCheckFileStatus(1);
    },
    /**
     * ファイル状態チェック
     * @param {０:改訂ボタン押下、1:プロパティ編集ボタン押下} btnKbn 
     */
    postCheckFileStatus(btnKbn){
      // ファイルロック状態チェック
      this.isProcessing = true;
      this.processDialogue(true);
      this.resetErrorFlg();
      let params = {
        FileKey: this.formInfo.fileKey,
        EditKbn: btnKbn,
      }
      API_STFMFM02C09_CheckFileStatus(params).then(async (response) => {
        //正常又は改訂回数が上限に達しているエラーの場合
        if (_.eq(response.result, "0000")) {
          // 改訂ボタン押下時
          if (btnKbn == 0) {
            this.moveToOtherForm("STFMFM02C08", [])
          }
          // プロパティ編集ボタン押下時
          if(btnKbn == 1){
            // プロパティ編集画面表示
            // 電子取引の場合とその他、書類種別用確認
            this.showUpdatePropertyForm(response);
          }
        } 
        // 編集ボタン押下且つバージョン上限達したエラーの場合は正常
        else if (btnKbn == 1 && _.eq(response.errorCD, "MTFM1430")){
          // プロパティ編集画面表示
          // 電子取引の場合とその他、書類種別用確認
          this.showUpdatePropertyForm(response);
        }
        else {
          // エラー表示
          this.errFlg = true;
          var errParams = [];
          if (response.msgParamList != null && response.msgParamList.length > 0){
            errParams = response.msgParamList;
          }
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, errParams)
            )
          );
          this.$nextTick(function () {
            this.formToTop();
            this.initFocus();
          });
        }
        this.isProcessing = false;
        this.processDialogue(false);
      }
      );
    },
    /**
     * 改訂ボタン押下
     */
    handleEditFileInfoBtnClicked(){
      this.postCheckFileStatus(0);
    },
    
    /**
     * 前ファイルボタン押下
     * @param {*} e 
     */
    handlePrevFileBtnClicked(e){
      this.resetErrorFlg();
      
      if (this.currentFileIdIndex == 0) {
        return;
      }
      
      const fileId = this.formInfo.fileIdList[this.currentFileIdIndex - 1];
      const version = 0;

      var fileKey = this.formInfo.fileKey;
      fileKey.fileId = fileId;
      fileKey.version = version;
      let params = {
        FileKey: fileKey
      };
      this.postFilePreviewDisplay(e, params, 1);
    },
    /**
     * 次ファイルボタン押下
     * @param {*} e 
     */
    handleNextFileBtnClicked(e){
      
      this.resetErrorFlg();

      if (this.currentFileIdIndex == this.formInfo.fileIdList.length - 1) {
        return;
      }
      // ファイルID取得
      const fileId = this.formInfo.fileIdList[this.currentFileIdIndex + 1];
      const version = 0;

      var fileKey = this.formInfo.fileKey;
      fileKey.fileId = fileId;
      fileKey.version = version;
      let params = {
        FileKey: fileKey
      };

      this.postFilePreviewDisplay(e, params, 1);
    },

    /**
     * バージョンプルダウン切り替え
     * @param {*} e 
     */
    handleChangeVersionSelect(e) {

      this.resetErrorFlg();

      this.currentVersionName = e.target.value;
     
      // ファイルID取得
      const fileId = this.formInfo.fileId;
      // バージョン取得
      const fileKey = this.versionList[e.target.options.selectedIndex];

      let params = {
        FileKey: fileKey
      };

      this.postFilePreviewDisplay(e, params, 2);
    },
    /**
     * 画面表示用データ取得POST
     * @param {*} イベント 
     * @param {*} post用パラメータ 
     * @param {*} 0:初期表示,1：ファイルID変更、2：バージョン変更 
     */
    postFilePreviewDisplay(e, params, flg) {
      this.processDialogue(true);
      this.isProcessing = true;
      let viewFileKeyList = JSON.parse(sessionStorage.getItem("ViewFileKeyList"))
      API_STFMFM02C09_FilePreviewDisplay({...params,viewFileKeyList}).then(async (response) => {
        //正常の場合
        if (_.eq(response.result, "0000") || _.eq(response.result, "0001")) {
          this.formInfo = response;
          if (flg == 0 || flg == 1){
            this.versionList = response.versionList;
            this.versionNameList = response.versionNameList;
          }
          // ファイルID変更の場合
          if (flg == 0 || flg == 1) {
            this.currentVersionNameListIndex = 0;
          }
          // バージョン変更の場合
          else {
            this.currentVersionNameListIndex = e.target.options.selectedIndex;
          }
          this.currentFileIdIndex = this.formInfo.fileIdList.indexOf(this.formInfo.fileId);
          this.editFormInfo(flg);
          if(this.isEtf){
            this.currentVersionName = this.versionNameList[this.currentVersionNameListIndex];
          }

          if (_.eq(response.result, "0000")) {
            // No9共通対応Temp問題対応
            if(this.isMobile){
              this.pdfUrl = response.fileData
            } else {
              const res = await getPDFApi(response);
              this.pdfUrl = res.objURL + "#view=Fit";
            }
          } else {
            // エラー表示
            this.errFlg = true;
            var errPara = "";
            this.pdfUrl = "";
            if (response.errorCD == "MTCL1105"){
              errPara = "表示";
            }
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [errPara])
              )
            );

          }
         
          this.$nextTick(function () {
              // 備考
              this.$refs.refRemarks.innerText = this.blandkToHyphen(this.formInfo.remarks);
              if(this.showUpdateReasonFlg){
                // 改訂理由
                this.$refs.refUpdateReason.innerText = this.blandkToHyphen(this.formInfo.updateReason);
              }
            this.formToTop();
            this.initFocus();
          });
        } else {
          // エラー表示
          this.pdfUrl = ""
          this.errFlg = true;
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
          this.formToTop();
        }
        this.isProcessing = false;
        this.processDialogue(false);
      });
      return;
    },
    /**
     * 初期フォーカス設定
     */
    initFocus() {
      // バージョン切替が有効の場合
      if (this.isEtf && !this.isChangeVersionSelectDisabled()) {
        this.$refs.refVersionSelect.focus();
      }
      else {
        this.$refs.refDownloadFileBtn.focus();
      }
      // 上記以外場合
      // フォーカス設定なし
    },
    /**
     * フラグの初期化
     */
    resetErrorFlg(){
      this.errors.splice(0);
    },

    /**
     * 項目の値設定
     * @param {*} response 
     */
    editFormInfo(flg){
      // ファイル件数
      this.fileIdCnt = this.formInfo.fileIdList.length;
      // 電子取引データフラグ
      if (this.formInfo.fileKey.folderKey.folderType == 1) {
        this.isEtf = true;
      }
      else {
        this.isEtf = false;
      }

      // バージョン件数
      if (this.isEtf) {
          this.versionCnt = this.versionList.length;
      }

      // ガイド文言
      if (this.isEtf) {
        this.guide = "ファイルや取引情報を変更する場合は［改訂］ボタンを、プロパティを変更する場合は［編集］ボタンをクリックしてください。";
      }
      else {
        this.guide = "プロパティを変更する場合は［編集］ボタンをクリックしてください。";
      }

      // 改訂ボタン表示
      if (this.isEtf) {
        if (this.formInfo.isBop){
          if(this.currentVersionNameListIndex == 0){
            this.showEditFileButton = true;
          }
          else{
            this.showEditFileButton = false;
          }
        }
        else
        {
          if (this.formInfo.canEditFile) {
            if(this.currentVersionNameListIndex == 0){
              this.showEditFileButton = true;
            }
            else{
              this.showEditFileButton = false;
            }
          }
          else{
            this.showEditFileButton = false;
          }
        }
      }
      else {
        this.showEditFileButton = false;
      }

      // 編集ボタン表示
      if (this.formInfo.isBop) {
        if(this.currentVersionNameListIndex == 0){
          this.showEditPropetyButton = true;
        }
        else{
          this.showEditPropetyButton = false;
        }
      }
      else {
        if (this.formInfo.canEditFile) {
          if(this.currentVersionNameListIndex == 0){
            this.showEditPropetyButton = true;
          }
          else{
            this.showEditPropetyButton = false;
          }
        }
        else {
          this.showEditPropetyButton = false;
        }
      }
      
      // 書類種別
      if (this.paperList[this.formInfo.paperType]){
        // その他の場合
        if (this.formInfo.paperType == 7){
          this.formInfo.paperTypeName = this.formInfo.otherPaperTypeName;
        }
        else{
          this.formInfo.paperTypeName = this.paperList[this.formInfo.paperType].name
        }
        
      }
      
      // 取引金額
      if (!this.isNullOrEmpty(this.formInfo.amount)){
        this.formInfo.amount = Number(this.formInfo.amount).toLocaleString();
      }

      // 更新履歴と作成履歴の表示
      if (this.isEtf){
        if(this.currentVersionNameListIndex == this.versionList.length - 1)
        {
          this.updateLabelName = "作成履歴";
          this.updateDateLabelName = "作成日時";
          this.updateTime = this.formInfo.createDate;
          this.updaterLabelName = "作成者";
          this.updater = this.formInfo.createName;
          this.showUpdateReasonFlg = false;
        }
        else
        {
          this.updateLabelName = "改訂履歴";
          this.updateDateLabelName = "改訂日時";
          this.updateTime = this.formInfo.updateDate;
          this.updaterLabelName = "改訂者";
          this.updater = this.formInfo.updateName;
          this.showUpdateReasonFlg = true;
        }
      }

      this.formInfo.businessOperatorName = "_" + this.formInfo.businessOperatorName
    },
    /**
     * null,empty判定
     * @param {チェック対象文字列} val 
     */
    isNullOrEmpty(val){
      if(val === null || val === ""){
        return true;
      }
      else{
        return false;
      }
    },
    /**
     * 金額入力済みかの判定
     */
    amountIsEmpty(){
      return !this.formInfo.amount || this.isNullOrEmpty(this.formInfo.amount);
    },
    /**
     * 画面の再表示
     */
    reloadForm(){
      location.reload();
    },
    /**
     * 画面の最上位に移動
     */
    formToTop(){
      window.scroll({ top: 0, behavior: 'smooth' });
    },
    /**
     * 他の画面に遷移
     */
    moveToOtherForm(formId, param){
      if (_.eq(formId, "STFMFM02C09")){
        this.reloadForm();
      }
      else{
        this.$router.push({
          name: formId,
          params: param
        });
      }
    },
    /**
     * 空白を"-"に変更
     */
    blandkToHyphen(val) {
      if(this.isNullOrEmpty(val)){
        return "-";
      }
      else{
        return val;
      }
    },
    // No4スキャナ保存対応-スキャナ保存読取要件チェック 
    checkFile() {
      this.resetErrorFlg();
      // if(!this.checkFileExtendion(this.formInfo.fileName)){
      //   this.errors.push(
      //     Common.createError(
      //       "MTFM8091",
      //       Common.getMessage("MTFM8091", [])
      //     )
      //   );
      //   return 
      // }
      this.processDialogue(true);
      API_STFMFM02C09_RequirementCheck({ fileKey: this.formInfo.fileKey}).then(
        (response) => {
          // 正常の場合
          if (_.eq(response.result, "0000")) {
            if (response.requirements) {
              this.fileCheckSuccessedDialog.content =
              Common.getMessage("MTFM8080",[response.resolution,response.gradation]);
            } else {
              this.fileCheckSuccessedDialog.content =
              Common.getMessage("MTFM8090",[response.resolution,response.gradation]);
            }
            this.fileCheckSuccessedDialog.show = true;
          } else {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
          this.processDialogue(false);
        } 
      )
    },
    // checkFileExtendion(fileName){
    //   var extentionList = [ "pdf", "jpeg", "jpg", "png", "gif", "bmp", "tiff", "tif", "webp", "svg"]
    //   if(this.isNullOrEmpty(fileName)){
    //     return false;
    //   }

    //   var list = fileName.split(".");
    //   // 拡張子なしの場合
    //   if(list.length <= 1 || this.isNullOrEmpty(list[list.length-1])){
    //     return false;
    //   }
    //   // ファイル拡張子取得
    //   const extension = list[list.length-1];
    //   // 許可拡張子の場合
    //   if (_.includes(extentionList, extension)) {
    //     return true;
    //   }
    //   return false;
    // },
    fileCheckConfirm() {
      this.fileCheckSuccessedDialog.show = false
    },
  },
  beforeRouteLeave(to, from) {
    if(to.path !== "/fm/edittransactioninfo"){
      sessionStorage.removeItem("ViewFileKeyList")
    } 
  },
};
</script>

<style scoped>
.padding-t-10px {
  padding-top: 10px
}
.link-back:hover{
  text-decoration:none;
}
.display-flex {
  display: flex;
}
.position-absolute {
  position: absolute;
}
.height-1020px{
  height: 1020px;
}
.ml-135px {
  margin-left: 135px
}
.ml-16px {
  margin-left: 16px
}
.mr-10px{
  margin-right: 10px
}

.justify-space-between {
  justify-content: space-between;
}
.mb-15px{
  margin-bottom: 15px;
}
.mt-15px {
  margin-top: 15px;
}
.mt-6px {
  margin-top: 6px;
}
.no-links{
	pointer-events:none;
	cursor:default;
	text-decoration:none;
  color: gray;
}
.single-pagination a.no-links::before {
  background-image: url(../../assets/images/denchouhou/icon_d-left_disable.png);
}
.single-pagination a.no-links::after {
  margin-left: 6px;
  background-image: url(../../assets/images/denchouhou/icon_d-right_disable.png);
}
.padding-b-5px{
  padding-bottom: 5px
}
.frm-item.grow.left{
    gap: 8px;
  }


@media (max-width: 768px) {
  .inner.block.padding-t-10px>.frm-row{
    flex-direction: column;
    justify-content: flex-start;
  }
  .frm-item.grow.left{
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 16px;
    padding-bottom: 8px;
  }

  .frm-item.grow.left>.frm-select{
    margin-left: 0;;
  }

  .frm-item.grow.right{
    width: 100%;
    margin-left: 0;
    border-top: 1px solid #CCCFD2;
    padding-top:20px;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 16px;
  }
  .frm-item.grow.right > .frm-btn-control{
    margin-left: 0;
    border-bottom: none;
  }
  .property-wrap .property-right{
    margin-left: 0;
    padding-top: 30px;
  }
  
  .frm-label.w-100px{
    width: 100%;
  }
  .display-flex{
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .display-flex .frm-label {
    position:relative;
    margin-left: 15px;
  }
  .display-flex .ml-110px{
    margin-left: 10px;
    margin-top: 0 !important;
  } 
  .property-left>.preview-area{
    width:calc(100vw - 50px);
    height: calc((100vw - 50px) * 1.48 ) ;
    position: relative;

  }
}


</style>
